import { getHeaderHeight } from "@/common/functions";
import { AD_LAYOUT_STUBS, AD_PLACEMENTS } from "@/common/consts";
import { mapGetters } from "vuex";

export default {
	...mapGetters(["topElementsHeight"]),
	title() {
		return this.$t("WordscapesGroupPageH1", {
			GroupName: this.groupInfo.name,
		});
	},
	isShowListTitle() {
		const scrollPosition = this.$store.state.window.scrollY;
		const listElement = this.$refs.list;
		return listElement ? scrollPosition > listElement.offsetTop : false;
	},
	isMasterGroup() {
		return this.groupInfo.name === "master";
	},
	items() {
		const items = this.isMasterGroup
			? this.packs
			: this.groupInfo.packsList;

		let tableAdCount = 1;
		const itemsPerAd = 3;
		const maxNumberOfAds = 5;

		return items.map((item, index) => {
			if (
				this.isSmallDevice &&
				index + 1 >= itemsPerAd &&
				(index + 1) % itemsPerAd === 0 &&
				index + 1 <= maxNumberOfAds * itemsPerAd
			) {
				tableAdCount++;
				item.ad = {
					stub: AD_LAYOUT_STUBS.MOB_IN_CONTENT,
					placement: AD_PLACEMENTS[`MOB_IN_CONTENT_${tableAdCount}`],
				};
			}
			return item;
		});
	},
	scrollOffset() {
		const headerHeight = getHeaderHeight(this.isSmallDevice);
		const headerOffset = this.$store.state.domElements.headerOffset;

		return headerHeight + headerOffset;
	},
	breadcrumb() {
		return [
			{
				label: this.$t("BreadcrumbWordscapesGroupPageText", {
					GroupName: this.groupInfo.name,
				}),
			},
		];
	},
};
